<template>
  <v-card flat class="pa-0 record-form">
    <div v-if="readonly" class="clinical-readonly">
      <div class="clinical-readonly__grid">
        <div
          v-for="field in readonlyFields"
          :key="field.key"
          v-show="hasReadonlyValue(field.value)"
          class="clinical-readonly__item"
        >
          <p class="clinical-readonly__label">{{ field.label }}</p>
          <p class="clinical-readonly__value">{{ field.value }}</p>
        </div>
      </div>
      <p v-if="!readonlyFields.some(field => hasReadonlyValue(field.value))" class="caption grey--text ma-0">—</p>
    </div>
    <v-row v-else no-gutters>
      <v-col cols="12">
        <v-text-field
          v-model="localModel.reason"
          outlined
          dense
          :label="_getLabel('HOSPITALIZATION_REASON')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="admissionDateFormatted"
          outlined
          dense
          :label="_getLabel('ADMISSION_DATE')"
          type="date"
          :max="todayDate"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.notes"
          outlined
          dense
          :label="_getLabel('NOTES')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <p class="caption grey--text text--darken-1 ma-0">
          {{ _getLabel('HOSPITALIZATION_DERIVED_STATUS_HINT') }}
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {
  timestampToDateInput,
  dateInputToClinicalTimestamp,
} from "@/constants/records.utils.js";

export default {
  name: "HospitalizationForm",
  props: {
    value: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      localModel: { ...this.value },
    };
  },
  computed: {
    todayDate() {
      return timestampToDateInput(Date.now());
    },
    readonlyFields() {
      return [
        ['reason', 'HOSPITALIZATION_REASON', this.localModel.reason],
        ['admissionDate', 'ADMISSION_DATE', this.formatDate(this.localModel.admissionDate)],
        ['notes', 'NOTES', this.localModel.notes],
      ].map(([key, label, value]) => ({ key, label: this._getLabel(label), value }));
    },
    /**
     * Data clínica validada pelo backend: nunca pode ficar no futuro.
     * O estado da internação (ativa até a alta) e os dados de alta não ficam
     * neste formulário: a alta é um fluxo próprio que finaliza o registro.
     */
    admissionDateFormatted: {
      get() {
        if (!this.localModel.admissionDate) return "";
        return timestampToDateInput(this.localModel.admissionDate);
      },
      set(val) {
        this.localModel.admissionDate = dateInputToClinicalTimestamp(val);
      },
    },
  },
  methods: {
    formatDate(value) {
      return Number.isFinite(value) ? this._getDateFromTimestamp(value) : "";
    },
    hasReadonlyValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== "";
    },
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.localModel)) {
          this.localModel = { ...(val || {}) };
        }
      },
      deep: true,
    },
    localModel: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.value)) {
          this.$emit("input", val);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.record-form .v-input { margin-bottom: 8px; }
.clinical-readonly__grid { display: grid; gap: 8px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
.clinical-readonly__item { background: #f5f6fa; border-radius: 8px; min-width: 0; padding: 10px 12px; }
.clinical-readonly__label { color: #667085; font-size: 11px; font-weight: 700; margin: 0 0 4px; }
.clinical-readonly__value { color: #193153; font-size: 14px; line-height: 1.45; margin: 0; overflow-wrap: anywhere; white-space: pre-wrap; }
@media (max-width: 599px) { .clinical-readonly__grid { grid-template-columns: 1fr; } }
</style>
